module.exports = __webpack_public_path__ + "img/logo-ticketshop.a3f8d19c.png";